import ZoomInSVG from "@design-system/ui-icons/vanilla/ZoomIn"
import { createIcon } from "../createIcon"

export const ZoomInIcon = createIcon(ZoomInSVG)
